import { createSelector } from 'reselect';

export const getSchedules = state => state.schedules;
export const isLoadingSchedules = createSelector(getSchedules, schedules => schedules.loading);
export const getSchedulesError = createSelector(getSchedules, schedules => schedules.error);
